export default function Header({ onLogout }) {
  return (
    <nav className="navbar navbar-dark bg-dark px-3">
      <span className="navbar-brand">Liver Admin</span>

      <div className="text-white">
        Welcome Admin
        <button className="btn btn-sm btn-danger ms-3" onClick={onLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
}